import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const ConatinerStyles = styled(motion.div)`
  display: flex;
  font-family: ${(props) => props.theme.font};
  position: relative;
  height: calc(100vh - 99px);

  .overviewImage {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }

  .no-drag {
    pointer-events: none;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;

export const variants = {
  hidden: { x: -1200, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.8 },

    // transition: {
    //   delayChildren: 0.5,
    // },
  },
  exit: { x: 1200, delay: 1, duration: 1 },
};

const Container = ({ children }) => (
  <ConatinerStyles
    variants={variants}
    initial="hidden"
    animate="show"
    exit="exit"
  >
    {children}
  </ConatinerStyles>
);

export default Container;
